import { fetchJson } from './client';

export const s3 = {
  getConfig: () => fetchJson('/s3/config'),
  setConfig: (config: any) => fetchJson('/s3/config', { method: 'POST', body: JSON.stringify(config) }),
  testConnection: () => fetchJson('/s3/test-connection', { method: 'POST' }),
  getPresignedUrl: (key: string) =>
    fetchJson<{ url: string }>('/s3/presigned-url', { method: 'POST', body: JSON.stringify({ key }) })
      .then(r => r.url),
};
